<template>
  <div class="bonus-manage">
    <!-- <div class="bonus-header">
        <a-row :gutter="24" type="flex" justify="space-between" align="top" class="select-container">
            <a-col>
                <span>基金 </span>
                <a-select size="large" v-model="fundCode" placeholder="请选择基金" style="width: 200px">
                    <a-select-option v-for="(item, index) in fundList" :key="index">
                        {{ item.fundName }}
                    </a-select-option>
                </a-select>
            </a-col>
            <a-col span="12" style="height: 40px;">
                <span>导入excel </span>
                <a-button @click="showDialog = true"> <a-icon type="upload" /> 选择文件 </a-button>
                <a href="" download="">下载格式模板入</a>
            </a-col>
            <a-col>
                <a-button type="primary">
                    搜索
                </a-button>
                <a-button @click="reset">重置</a-button>
            </a-col>
        </a-row>
        <div class="mg">
            <a-button type="primary" icon="plus" @click="handleAdd">
                新增
            </a-button>
            <a-button type="primary" icon="delete" @click="add">
                删除
            </a-button>
        </div>

    </div> -->
    <div class="table-page-search-wrapper bonus-header">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="方案名称">
              <a-input placeholder="请输入方案名称" v-model="queryParam.projectName"></a-input>
            </a-form-item>
          </a-col>-->
          <!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="产品名称">
                 <a-input placeholder="请输入产品名称" v-model="queryParam.fundName"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="产品名称">
              <a-select
                v-model="queryParam.fundCode"
                show-search
                placeholder="请选择产品"
                style="width: 180px"
              >
                <a-select-option
                  v-for="(item, index) in fundList"
                  :key="index"
                  :value="item.fundCode"
                >
                  {{ item.fundCode }} / {{ item.fundName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="分配方式">
                <a-select
                  v-model="queryParam.allotType"
                  placeholder="请选择分配方式"
                >
                  <a-select-option
                    :value="item.value"
                    v-for="item in allot_type"
                    :key="item.value"
                  >
                    {{ item.text }}
                  </a-select-option>
                </a-select>
                <!-- <j-dict-select-tag type="list" v-model="queryParam.allotType" dictCode="allotType" placeholder="请选择分配方式"/> -->
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="是否启用">
                <a-select
                  v-model="queryParam.isOpen"
                  placeholder="请选择是否启用"
                >
                  <a-select-option :value="'0'">
                    否
                  </a-select-option>
                  <a-select-option :value="'1'">
                    是
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
        <div class="mg">
          <!-- <a-col style="margin-bottom: 20px;"> -->
          <a-button type="primary" icon="plus" @click="handleAdd">
            新增
          </a-button>
          <!-- <a-button type="primary" icon="delete" @click="batchDel">
                    删除
                </a-button> -->
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item @click="batchDel"
                ><a-icon type="primary" />批量删除</a-menu-item
              >
            </a-menu>
            <a-button style="margin-left: 8px">
              批量操作 <a-icon type="down"
            /></a-button>
          </a-dropdown>
          <!-- </a-col>
            <a-col :xl="8" :lg="10" :md="12" :sm="24"> -->
          <!--                <span class="dr">导入excel </span>-->
          <!--                <a-button @click="showDialog = true"> <a-icon type="upload" /> 选择文件 </a-button>-->
          <!--                <a href="" download="">下载格式模板</a>-->
          <!-- </a-col> -->
        </div>
      </a-form>
    </div>
    <a-table
      ref="tableSelect"
      :columns="columns"
      rowKey="id"
      :data-source="dataSource"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :pagination="ipagination"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">修改 </a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(record.id)"
              >
                <a>删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
      <template slot="shareType" slot-scope="text, record">
        <span v-for="(item, index) in share_type" :key="index">
          <span v-if="record.shareType === item.value">
            {{ item.text }}
          </span>
        </span>
      </template>
      <template slot="allotType" slot-scope="text, record">
        <span v-for="(item, index) in allot_type" :key="index">
          <span v-if="record.allotType === item.value">
            {{ item.text }}
          </span>
        </span>
      </template>
      <template slot="isOpen" slot-scope="text, record">
        <span>{{ record.isOpen ? '是' : '否' }}</span>
      </template>
    </a-table>

    <bonus-manage-modal
      :share_type="share_type"
      :allot_type="allot_type"
      ref="modalForm"
      @ok="modalFormOk"
    ></bonus-manage-modal>
    <a-modal title="上传文件" :visible="showDialog">
      <a-upload-dragger
        name="file"
        :multiple="true"
        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          点击或拖拽上传文件
        </p>
      </a-upload-dragger>
      <template slot="footer">
        <a-button key="back" @click="showDialog = false">
          取消
        </a-button>
        <a-button key="submit" type="primary" icon="download" @click="upload">
          导入
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import bonusManageModal from './add.vue';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import { getAction } from '@/api/manage';
import { queryByFundCode } from '@/api/api';
const columns = [
  //  'fundCode','fundName','noticeId','isOpen','projectName','shareYear','allotType','shareType','recordDate','exDividendDate','paymentDate'
  {
    title: '产品名称',
    dataIndex: 'fundName',
    key: 'fundName'
  },
  {
    title: '单位分红',
    dataIndex: 'unitProfit',
    key: 'unitProfit'
  },
  {
    title: '分配方式',
    dataIndex: 'allotType',
    key: 'allotType',
    ellipsis: true,
    scopedSlots: { customRender: 'allotType' }
  },
  {
    title: '是否启用',
    dataIndex: 'isOpen',
    key: 'isOpen',
    scopedSlots: { customRender: 'isOpen' }
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  name: 'BonusManage',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JDictSelectTag,
    bonusManageModal
  },

  data() {
    return {
      showDialog: false,
      fundCode: undefined,
      confirmLoading: false,
      columns,
      selectedRowKeys: [],
      share_type: [],
      allot_type: [],
      fundList: [],
      url: {
        list:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundBonus/list',
        delete:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundBonus/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundBonus/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/BonusManage/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/BonusManage/importExcel'
      }
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/share_type`,
        {}
      ).then(res => {
        if (res.success) {
          this.share_type = res.result;
          console.log(this.share_type);
        } else {
          this.$message.error(res.message);
        }
      });
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/allot_type`,
        {}
      ).then(res => {
        if (res.success) {
          this.allot_type = res.result;
          console.log(this.allot_type);
        } else {
          this.$message.error(res.message);
        }
      });
      queryByFundCode().then(res => {
        if (res.success) {
          this.fundList = res.result;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    handleChange() {},
    reset() {
      this.fundCode = '';
    },
    upload() {
      this.showDialog = false;
    }
  }
};
</script>
<style lang="less" scoped>
.bonus-manage {
  background: #fff;
  padding: 25px;
  .bonus-header {
    .mg {
      margin-bottom: 20px;
      span.dr {
        margin-left: 35px;
        margin-right: 15px;
      }
    }
    button {
      margin-right: 10px;
    }
  }
}
</style>
